import React from "react";
import { motion } from "framer-motion";
import { DownloadIcon, InfinityIcon, ShieldCheckIcon, ZapIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { CountdownTimer } from "./CountdownTimer";
import { ScarcityBar } from "./ScarcityBar";
const badges = [{
  icon: DownloadIcon,
  text: "Descarga inmediata"
}, {
  icon: ZapIcon,
  text: "Pago único"
}, {
  icon: InfinityIcon,
  text: "Acceso de por vida"
}, {
  icon: ShieldCheckIcon,
  text: "Garantía de 7 días"
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-neutral-950" data-id="element-101" data-mp="xbpbb0flzqce">
      {/* subtle radial glow */}
      <div className="pointer-events-none absolute inset-x-0 top-0 h-[420px] opacity-40" style={{
      background: "radial-gradient(60% 100% at 50% 0%, rgba(245,184,0,0.18) 0%, rgba(11,11,11,0) 70%)"
    }} data-id="element-102" data-mp="s9q93tvluzh1" />
      <div className="relative mx-auto flex max-w-lg flex-col items-center px-4 pb-12 pt-8 text-center sm:pt-12" data-id="element-103" data-mp="382p9fo05jxqf">
        {/* brand */}
        <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-amber-400/10 px-4 py-1.5" data-id="element-104" data-mp="3j9u0yz9q1olt">
          <span className="text-lg" data-id="element-105" data-mp="3o5j1p5xh9bjp">🔧</span>
          <span className="font-display text-xs font-bold uppercase tracking-widest text-amber-300" data-id="element-106" data-mp="39b4gcyqfxq1v">
            Sistema Técnico PRO 360™
          </span>
        </div>

        <h1 className="font-display text-3xl font-extrabold leading-[1.1] text-white sm:text-4xl" data-id="element-107" data-mp="30i19xae7qdgq">
          Monta un negocio profesional de reparación de electrodomésticos{" "}
          <span className="text-amber-400" data-id="element-108" data-mp="35aueny9ollst">en un solo día</span>
        </h1>

        <p className="mt-4 text-base leading-relaxed text-white/70" data-id="element-109" data-mp="2qlenwia5hgd4">
          Aunque todavía tengas pocos clientes. Más de 300 plantillas, procesos,
          protocolos y herramientas listas para usar para{" "}
          <span className="font-semibold text-white" data-id="element-110" data-mp="2hjymv1586qlk">cobrar con confianza</span>,
          organizar tu taller y operar como un técnico profesional desde el
          primer servicio.
        </p>

        {/* mockup */}
        <motion.img initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} src="https://cdn.magicpatterns.com/uploads/gEdJzksD4ULAQpfesaPJPF/reparaciones_mockup_sin_fondo.png" alt="Sistema Técnico PRO 360 — paquete completo con manuales, plantillas y sistemas premium" className="mx-auto my-8 w-full max-w-md drop-shadow-2xl" data-id="element-111" data-mp="s3usu27hfid9" />

        <div id="hero-cta-anchor" className="w-full" data-id="element-112" data-mp="16345wt0e5wd0">
          <CtaButton label="Quiero el Sistema Técnico PRO 360" data-id="element-113" data-mp="112pv537eo8ba" />
        </div>

        {/* Timer directly under the offer button */}
        <div className="mt-5 w-full rounded-2xl border border-white/10 bg-white/[0.03] p-4" data-id="element-114" data-mp="x0306tffu79v">
          <CountdownTimer data-id="element-115" data-mp="3lt74enpyzlso" />
        </div>

        <ScarcityBar className="mt-4" data-id="element-116" data-mp="3lu9tqr7n9g6h" />

        {/* badges */}
        <ul className="mt-6 grid w-full grid-cols-2 gap-2.5" data-id="element-117" data-mp="3hqah4jphj1ie">
          {badges.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex items-center justify-center gap-1.5 rounded-lg border border-white/10 bg-white/[0.03] px-2 py-2.5 text-xs font-semibold text-white/80" data-id="element-118" data-mp="1xavymn782e8u">
              <Icon className="h-4 w-4 shrink-0 text-amber-400" data-id="element-119" data-mp="267whkebivk4w" />
              {text}
            </li>)}
        </ul>

        <p className="mt-4 text-xs text-white/50" data-id="element-120" data-mp="2g02kuk785nze">
          💱 El cambio de moneda es automático según tu país.
        </p>
      </div>
    </header>;
}